import { render, staticRenderFns } from "./headView.vue?vue&type=template&id=bdc4a02a&scoped=true"
import script from "./headView.vue?vue&type=script&lang=js"
export * from "./headView.vue?vue&type=script&lang=js"
import style0 from "./headView.vue?vue&type=style&index=0&id=bdc4a02a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc4a02a",
  null
  
)

export default component.exports